import React,{useEffect,useRef} from "react";
import {TabNavigator as NativeComponent} from "vritra";
import ReactDOM from "react-dom/client";


export default function TabNavigator(props){
    const {}=props;
    const state=useRef({
        ref:useRef(),
        element:null,
        tabs:mendTabs(props.tabs),
    }).current;
    useEffect(()=>{
        const {ref,tabs}=state;
        const parent=ref.current,{domref}=props;
        parent.innerHTML="";
        const element=state.element=NativeComponent({...props,parent,tabs});
        if(domref){
            domref.current=element;
        }
    },[...statics.propkeys.map(key=>props[key]),state.tabs]);
    return React.createElement("div",{
        ref:state.ref,
        id:`tabnavigatorwrapper${props.id||""}`,
        className:props.className,
        style:{display:"inline"},
    });
}

const statics={
    propkeys:[
        "id","className","headerClassName","containerClassName",
        "style","tintColor","tabTextColor","memorize",
    ],
}

const mendTabs=(tabs)=>{
    tabs?.forEach(tab=>{
        const {renderContent}=tab;
        tab.renderContent=({parent,context})=>{
            const wrapperEl=document.createElement("div");
            wrapperEl.style.display="inline";
            const root=ReactDOM.createRoot(wrapperEl);
            root.render(renderContent({context}));
            parent.appendChild(wrapperEl);
            return wrapperEl;
        }
    });
    return tabs;
}
